import { Persistence } from "../Infra/Persistence";
import { SmartAuthErrorReason, SmartAuthProvider } from "../Logic/SmartAuthManager";
import { isMobile } from "./mobile";
export class SmartAuthWindow {
    constructor(smartAuthManager) {
        this.smartAuthManager = smartAuthManager;
        this.authWindow = null;
        this.popupPoll = null;
    }
    async createSmartAuthWindow(provider, type, organizationId, sandboxMode) {
        this.authWindow = window.open("", "_blank");
        if (this.authWindow) {
            const fontSize = isMobile() ? "font-size: 30px;" : "";
            this.authWindow.document.write(`<html><body><div style="font-family: sans-serif;text-align: center;margin-top: 200px; ${fontSize}">Loading...</div></body></html>`);
        }
        try {
            const resolvedOrganizationId = typeof organizationId === "function" ? await organizationId() : organizationId;
            const url = await this.smartAuthManager.startSmartAuth(provider, type, this.smartAuthManager.getRedirectUri(provider), resolvedOrganizationId, undefined, undefined, sandboxMode);
            this.subscribeToWindow(provider);
            if (this.authWindow) {
                this.authWindow.location.href = url;
            }
        }
        catch (e) {
            if (this.authWindow) {
                this.authWindow.close();
                void this.smartAuthManager.onSmartAuthError("Failed to initialize auth session");
            }
            throw e;
        }
    }
    subscribeToWindow(provider) {
        if (!this.authWindow)
            return;
        const receiveMessage = (event) => {
            var _a, _b;
            if (!this.authWindow)
                return;
            if (event.origin !== window.location.origin)
                return;
            if (typeof event.data !== "string")
                return;
            if (!event.data.startsWith("healthex.smart.callback:"))
                return;
            if (this.popupPoll !== null) {
                clearInterval(this.popupPoll);
                this.popupPoll = null;
            }
            window.removeEventListener("message", receiveMessage);
            if (provider === SmartAuthProvider.EPIC) {
                const data = new URLSearchParams(event.data.split(":")[1]);
                const error = data.get("error");
                const code = data.get("code");
                const state = data.get("state");
                if (error) {
                    void this.smartAuthManager.onSmartAuthError(error);
                }
                else if (code) {
                    void this.smartAuthManager.onSmartAuthComplete(code, state !== null && state !== void 0 ? state : "", this.smartAuthManager.getRedirectUri(provider));
                }
                else {
                    void this.smartAuthManager.onSmartAuthError("Failed to retrieve code parameter");
                }
            }
            else if (provider === SmartAuthProvider.CLEAR_IAL2) {
                const params = event.data.split(":");
                const state = (_a = params.pop()) !== null && _a !== void 0 ? _a : "NO STATE";
                const code = (_b = params.pop()) !== null && _b !== void 0 ? _b : "NO CODE";
                void this.smartAuthManager.onSmartAuthComplete(code, state, this.smartAuthManager.getRedirectUri(provider));
            }
        };
        window.addEventListener("message", receiveMessage, false);
        this.popupPoll = window.setInterval(() => {
            var _a;
            if ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.closed) {
                window.setTimeout(() => {
                    if (this.popupPoll !== null) {
                        clearInterval(this.popupPoll);
                        window.removeEventListener("message", receiveMessage);
                        void this.smartAuthManager.onSmartAuthError("The login window was closed", SmartAuthErrorReason.LOGIN_WINDOW_CLOSED);
                    }
                }, 500);
            }
        }, 500);
    }
    static postSmartCallbackMessageToOriginalWindowIfAppropriate(smartAuthResult) {
        const smartAuthData = new Persistence().getSmartAuthData();
        if (!smartAuthData)
            return false;
        switch (smartAuthData.provider) {
            case SmartAuthProvider.EPIC:
                if (smartAuthData.isEHRLaunch)
                    return false;
                window.opener.postMessage(`healthex.smart.callback:${location.search.substring(1)}`, window.location.origin);
                break;
            case SmartAuthProvider.CLEAR_IAL2:
                if (!smartAuthResult)
                    return false;
                window.opener.postMessage(`healthex.smart.callback:${smartAuthResult.code}:${smartAuthResult.state}`, window.location.origin);
                break;
            default:
                console.warn(`Unknown callback provider: ${JSON.stringify(smartAuthData)}`);
                return false;
        }
        window.close();
        return true;
    }
}
